module.exports = "/assets/73657c4cab72d1f43c6fee70c0c9d63d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MH.png
// module id = 1614
// module chunks = 0